export default "__VITE_ASSET__BhWX1Aib__"